// WARN: Non production-ready code, implemented just for transmuxing demo
//TODO: FIX WORKER IN NEW PARSER
/*
 Details:
 After rebuild in MMP, there are some changes which breaks build:
 1) class in CoreParser is changed to object with methods, but object is not defined
 2) parcel changes typeof operator to method, which breaks moduleInterop after build
 */

import { ConfigConsumer } from '@configProvider/ConfigConsumer';
import { TEventBus } from '@eventBus/EventBus';
import { Fragment } from '@fragment/Fragment';
import { TFragmentLocalParser } from '@fragmentParser/FragmentLocalParser';
import { IFragmentParserConfig } from '@fragmentParser/FragmentParser.config';
import { FragmentParserEvents } from '@fragmentParser/FragmentParser.events';
import { FragmentsFilterEvents } from '@fragmentsFilter/FragmentsFilter.events';
import { Logger, TLogger } from '@logger/Logger';
import { BasePlaylistRotationControllerEvents } from '@streamLoader/BasePlaylistRotationController/BasePlaylistRotationController.events';
import { StreamLoaderModuleEvents } from '@streamLoader/StreamLoader.events';
import bind from '@utils/decorators/bind';

export class FragmentParser extends ConfigConsumer<IFragmentParserConfig> {
  private _localFragmentParser: TFragmentLocalParser | null = null;
  private _workerFragmentParser: Worker | null = null;

  private _fragmentsCache: Fragment[] = [];

  private _isCacheRequired: boolean = false;

  private readonly _onFragmentReleasedListener: string;
  private readonly _onVODPlaylistDetectedListener: string;
  private readonly _onSimplePlaylistDetectedListener: string;
  private readonly _onLLPlaylistDetectedListener: string;
  private readonly _onReleaseFromCacheRequestedListener: string;

  private readonly _logger: TLogger;

  constructor(eventBus: TEventBus) {
    super('fragmentParser', eventBus);
    this._logger = Logger(eventBus, 'Doppio - FragmentParser');

    this._logger = Logger(this._eventBus, 'Doppio - FragmentParser');

    this._onFragmentReleasedListener = this._eventBus.subscribe(FragmentsFilterEvents.fragmentsReleased, this._onFragmentsLoaded);

    this._onVODPlaylistDetectedListener = this._eventBus.subscribe(
      StreamLoaderModuleEvents.playlistRotator.playlistType.vodDetected,
      this._onVODPlaylistDetected,
    );
    this._onSimplePlaylistDetectedListener = this._eventBus.subscribe(
      StreamLoaderModuleEvents.playlistRotator.playlistType.simpleDetected,
      this._onLivePlaylistDetected,
    );
    this._onLLPlaylistDetectedListener = this._eventBus.subscribe(
      StreamLoaderModuleEvents.playlistRotator.playlistType.llDetected,
      this._onLivePlaylistDetected,
    );

    this._onReleaseFromCacheRequestedListener = this._eventBus.subscribe(
      BasePlaylistRotationControllerEvents.fragments.requestReleaseFromCache,
      this._onReleaseFromCacheRequested,
    );
  }

  @bind
  public destroy(): void {
    super.destroy();

    this._eventBus.unsubscribe(this._onFragmentReleasedListener);
    this._eventBus.unsubscribe(this._onVODPlaylistDetectedListener);
    this._eventBus.unsubscribe(this._onSimplePlaylistDetectedListener);
    this._eventBus.unsubscribe(this._onLLPlaylistDetectedListener);
    this._eventBus.unsubscribe(this._onReleaseFromCacheRequestedListener);
  }

  @bind
  public _handleConfigUpdated(): void {}

  @bind
  private _onReleaseFromCacheRequested({ msn }: { msn: number }): void {
    const fragment: Fragment | undefined = this._fragmentsCache.find((frag) => frag.msn === msn);

    if (!fragment) {
      return;
    }

    this._eventBus.publish(FragmentParserEvents.fragments.fragmentsParsed, [fragment]);
  }
  @bind
  private _onLivePlaylistDetected(): void {
    this._isCacheRequired = false;
    this._fragmentsCache = [];
  }

  @bind
  private _onVODPlaylistDetected(): void {
    this._isCacheRequired = true;
  }
  @bind
  private async _onFragmentsLoaded(fragments: Fragment[]): Promise<void> {
    this._logger.verbose(`Sending fragment ${fragments.map((fragment) => fragment.getMsnPn())} for parsing`);

    this._eventBus.publish(FragmentParserEvents.fragments.fragmentsParsed, fragments);
    return;
    /*
    const fragmentsForBypass: Fragment[] = fragments.filter(
      ({ isTransmuxingBypassRequested, data }) => isTransmuxingBypassRequested && data,
    );
    const fragmentsToTransmux: Fragment[] = fragments.filter(
      ({ isTransmuxingBypassRequested, data }) => !isTransmuxingBypassRequested || !data,
    );

    if (fragmentsForBypass.length) {
      this._onFragmentsParsed(fragmentsForBypass);
    }

    if (fragmentsToTransmux.length) {
      if (!this.config.workerMode) {
        const parser: TFragmentLocalParser = await this._getLocalParser();
        fragmentsToTransmux.forEach((fragment) => parser.addFragment(fragment));
        return;
      }

      if (this._workerFragmentParser) {
        fragmentsToTransmux.forEach((fragment) => this._workerFragmentParser!.postMessage(fragment));
      }
    }
     */
  }
}
